export const takeLastSearchFilter = "takeLastSearchFilter";